import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { Field } from "features/admin/Products/types";
import { useStyles } from "./styles";
import { Controller } from "react-hook-form";
import clsx from "clsx";

interface SelectFieldProps {
  item: Field;
  control: any;
  reset: boolean | undefined;
  setValue: any;
}

const SelectField: React.FC<SelectFieldProps> = ({
  item,
  control,
  reset,
  setValue,
}) => {
  const classes = useStyles();
  const [selection, setSelection] = React.useState<string>("");
  const labelId = `${item.name}-label`;

  const handleChange = (event: any, onChange: any) => {
    setSelection(event.target.value);
    onChange(event.target.value);
  };

  useEffect(() => {
    if (reset !== undefined) {
      let deff = item.value !== undefined ? item.value : "";
      setSelection(deff);
    }
  }, [reset]);

  useEffect(() => {
    let deff = item.value !== undefined ? item.value : "";
    setSelection(deff);
    setValue(item.name, item.value);
  }, []);

  return (
    <FormControl required={item.required} className={classes.formControl}>
      <InputLabel id={labelId}>{item.title}</InputLabel>
      <Controller
        name={item.name}
        control={control}
        value={selection}
        defaultValue={selection}
        render={({ name, onChange }) => (
          <Select
            labelId={labelId}
            id={item.name}
            value={selection}
            name={name}
            onChange={(e) => handleChange(e, onChange)}
            inputProps={{
              id: `${item.name}-native-input`,
              "aria-labelledby": labelId,
            }}
            className={classes.selectEmpty}
            disabled={item.disabled}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {item.options!.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        )}
      />
      {item.required && <FormHelperText>Задължително</FormHelperText>}
    </FormControl>
  );
};

export default SelectField;
